import * as textConstants from '../../../text/constants';

const { SIZES: TEXT_SIZES, APPEARANCES, TYPES, WEIGHTS } = textConstants;
const { small, medium, large } = TEXT_SIZES;

const SIZES = {
  small,
  medium,
  large,
};

export { SIZES, APPEARANCES, TYPES, WEIGHTS };
